import { useSetFrBoloQueueFilterState } from '../../fr-events-list-page/state/fr-shared-queue-filters-context';
import { QueueSearchInput } from '../../queues/components/queue-search-input';
import { observer } from 'mobx-react-lite';
import { ButtonProps } from '@cad-arc';
import { useCallback } from 'react';

export const FrQueueSearchInput = observer(
    (props: { searchButtonVariant?: ButtonProps['variant'] }) => {
        const { setQueueFilterQuery } = useSetFrBoloQueueFilterState();

        const setFilterQuery = useCallback(
            (value: string) => {
                setQueueFilterQuery(value);
            },
            [setQueueFilterQuery]
        );

        return <QueueSearchInput {...props} onSetQueueFilterQuery={setFilterQuery} />;
    }
);
